import { makeStyles, createStyles } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
//import { useCallback } from "react";
// import InputAdornment from "@material-ui/core/InputAdornment";
// import iconLocation from "../../images/icons/Location.png";
import { useTranslation } from "react-i18next";
const useStyles = makeStyles((theme) =>
    createStyles({
        searchLocation: {
            width: "100%",
            border: 0,
            fontFamily: "Josefin Sans",
            "& input, .MuiInputBase-input": {
                padding: 0,
                fontSize: 14
            },
            [theme.breakpoints.down("sm")]: {
                border: "none",
                borderRadius: 0
            },
            [theme.breakpoints.down("xs")]: {
                border: "none",
                borderRadius: 0
            },
        },
        // icon: {
        //     [theme.breakpoints.down("sm")]: {
        //         display: "none"
        //     },
        //     [theme.breakpoints.down("xs")]: {
        //         display: "none"
        //     },
        // },
        "@global": {
            ".MuiInput-underline:before, .MuiInput-underline:after": {
                display: "none"
            },
        },
    })
);

export function SearchPrice(props: {
    handleChange?: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
    placeholder?: string;
    defaultValue?: string;
     id?: string; 
    name?: string;  
}) {
    const classes = useStyles();
    const { t } = useTranslation<'common'>();

    return (
        <TextField
            defaultValue={props.defaultValue || ""}
            placeholder={props.placeholder || t("searchBar.price")}
            className={classes.searchLocation}
            id={props.id}  // Use passed id instead of hardcoded one
            name={props.name}  // Pass name for form handling
            onChange={(e) => {
                //console.log(`SearchPrice value changed: ${e.target.value}`);
                props.handleChange?.(e);
            }}
            InputProps={{
                autoComplete: "off",
            }}
        />
    );
}
